import Cookies from "js-cookie";

export const useDisableCookies = (cookieName: string) => {
  return () => {
    //@ts-ignore
    window.cookieStore.delete(cookieName);

    Object.keys(Cookies.get()).forEach(function (cookieName) {
      var neededAttributes = {
        // Here you pass the same attributes that were used when the cookie was created
        // and are required when removing the cookie
      };
      Cookies.remove(cookieName, neededAttributes);
    });
    window.location.reload();
  };
};
